import { useState } from "react";

export const useExitModal = () => {
  const [exit, setExit] = useState({
    isVisible: false,
    message: "Atenção",
  });

  return {
    exit,
    setExit,
  };
};
